import { routes2 } from '@linqpal/models'

export const getExistingInvoiceInfo = async (invoiceId: string) => {
  try {
    const existingInvoiceInfo = await routes2.invoice.showInvoiceIdle({
      invoiceId,
    })
    return existingInvoiceInfo
  } catch (err) {
    console.error(err)
    return null
  }
}
